// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__27WgB","footer":"ReportModalFilter_footer__uRd6w"};